<script>
import { authComputed } from '@state/helpers'

import MetisMenu from 'metismenujs/dist/metismenujs'

export default {
  components: {},
  data() {
    return {
      inbox_count: 0,
      inactive: true,
      timeout: '',
    }
  },
  computed: {
    ...authComputed,
  },
  mounted: function() {
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu('#side-menu')
  },
  created() {
    // this.fetchData();
    //
    // setInterval(() => { if(!this.inactive) { this.fetchData(); } }, 10000); // 10 seconds
    //
    // document.onmousemove = () => { this.inactive = false; clearTimeout(this.timeout); this.timeout = setTimeout(() => { this.inactive = true; }, 300000); } // 5 minutes
  },
  methods: {
    fetchData() {
      if(this.hasRole(['Dev','Admin','Admin Employee'])) {
        this.$http.get('/api/inbox/fetch', {params: {total: 0, selects: ['id'], wheres: { unseen: 1 }}}).then(res => {
          // console.log(res);
          this.inbox_count = res.data.data.length;
        }).catch(res => {
          // this.popupErrors(res);
        });
      }
    },
  },
}
</script>

<template>
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <ul id="side-menu" class="metismenu">
      <li class="menu-title">Navigation</li>
      <li><router-link to="/" tag="a" class="waves-effect" active-class="active" exact>
        <Icon icon="ri:dashboard-line" /> <span>Dashboard</span>
      </router-link></li>
      <li><router-link to="/contacts" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin','Admin Employee'])">
        <Icon icon="ri:account-box-line" /> <span>Contacts</span>
      </router-link></li>
      <li><router-link to="/listings" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin','Admin Employee'])" disabled>
        <Icon icon="ri:home-2-line" /> <span>Listings</span>
      </router-link></li>
      <li><router-link to="/carts" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin','Admin Employee'])">
        <Icon icon="ri:shopping-cart-line" /> <span>Carts</span>
      </router-link></li>
      <!-- <li><router-link to="/people" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin','Admin Employee'])">
        <i class="remixicon-user-voice-line"></i> <span>People</span>
      </router-link></li> -->
      <!-- <li><router-link to="/leads" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin','Admin Employee','Lead Admin'])">
        <i class="remixicon-customer-service-line"></i> <span>Lead Reporting</span>
      </router-link></li> -->
      <!-- <li><router-link to="/myleads" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Lead User'])">
        <i class="remixicon-customer-service-line"></i> <span>My Leads</span>
      </router-link></li> -->

      <li v-if="hasRole(['Dev','Admin','Admin Employee','Admin Social'])" class="menu-title mt-2">Website/SEO</li>
      <li><router-link to="/pages" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin','Admin Employee','Admin Social'])">
        <Icon icon="ri:book-open-line" /> <span>Pages</span>
      </router-link></li>
      <li><router-link to="/blogs" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin','Admin Employee','Admin Social'])">
        <Icon icon="ri:newspaper-line" /> <span>Blog</span>
      </router-link></li>
      <li><router-link to="/vendors" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin','Admin Employee','Admin Social'])">
        <Icon icon="ri:store-2-line" /> <span>Vendors</span>
      </router-link></li>
      <li><router-link to="/faqs" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin','Admin Employee','Admin Social'])">
        <Icon icon="ri:questionnaire-line" /> <span>FAQ</span>
      </router-link></li>
      <li><router-link to="/testimonials" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin','Admin Employee','Admin Social'])">
        <Icon icon="ri:star-line" /> <span>Testimonials</span>
      </router-link></li>
      <li><router-link to="/file-manager" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin','Admin Employee','Admin Social'])">
        <Icon icon="ri:folder-2-line" /> <span>File manager</span>
      </router-link></li>
      <li><router-link to="/page-views" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin','Admin Employee','Admin Social'])">
        <Icon icon="ri:bar-chart-2-line" /> <span>Page Views</span>
      </router-link></li>
      <li><router-link to="/inbox" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin','Admin Employee','Admin Social'])">
        <Icon icon="ri:mail-open-line" /> <span v-if="inbox_count" class="badge badge-success badge-pill float-right" v-tippy :content="inbox_count+' unread message(s)'">{{inbox_count}}</span><span>Inbox</span>
      </router-link></li>
      <li><router-link to="/packages" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin','Admin Employee'])">
        <Icon icon="ri:hand-heart-line" /> <span>Packages/Services</span>
      </router-link></li>

      <li v-if="hasRole(['Dev','Admin','Admin Employee'])" class="menu-title mt-2">Admin</li>
      <li><router-link to="/docs" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin','Admin Employee','Admin Social'])">
        <Icon icon="ri:file-edit-line" /> <span>Docs</span>
      </router-link></li>
      <li><router-link to="/trackers" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin','Admin Employee','Admin Social'])">
        <Icon icon="ri:footprint-line" /> <span>Trackers</span>
      </router-link></li>

      <li v-if="hasRole(['Dev'])" class="menu-title mt-2">Dev</li>
      <li><router-link to="/tasks" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin'])">
        <Icon icon="ri:checkbox-line" /> <span>Tasks</span>
      </router-link></li>
      <li><router-link to="/websites" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin'])">
        <Icon icon="ri:computer-line" /> <span>Websites</span>
      </router-link></li>
      <li><router-link to="/mlss" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin'])">
        <Icon icon="ri:building-2-line" /> <span>MLSs</span>
      </router-link></li>
      <!-- <li><router-link to="/leadrecipients" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin'])">
        <i class="remixicon-group-line"></i> <span>Lead Recipients</span>
      </router-link></li> -->
      <!-- <li><router-link to="/leadtypes" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin'])">
        <i class="remixicon-user-settings-line"></i> <span>Lead Types</span>
      </router-link></li> -->
      <li><router-link to="/dblogs" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin'])">
        <Icon icon="ri:bug-line" /> <span>DB Logs</span>
      </router-link></li>
      <li><router-link to="/communications" tag="a" class="waves-effect" active-class="active" v-if="hasRole(['Dev','Admin'])">
        <Icon icon="ri:chat-history-line" /> <span>Com Logs</span>
      </router-link></li>

    </ul>
    <div class="clearfix"></div>
  </div>
  <!-- End Sidebar -->
</template>

<style lang="scss">
@import '~metismenujs/scss/metismenujs';
</style>
